/* eslint-disable no-use-before-define */
/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */



import {
	addIsChecking,
	removeIsChecking,
	addHasChecked,
	addHasUserData,
} from './actions';
import { fetchLinesAggs, fetchLineHistorySummaries } from './api';
import { selectHasChecked, selectIsChecking } from '../selectors';

const thunkCheckSurveyHistory = survey => async (dispatch, getState) => {
	const { customer, lineName, jobNumber } = survey;
	if (!selectHasChecked(getState(), survey) && !selectIsChecking(getState(), survey)) {
		dispatch(addIsChecking(survey));
		const linesAggs = await fetchLinesAggs({ customer, lineName, jobNumber });
		const hasLinesAggs = linesAggs && linesAggs.length;
		if (!hasLinesAggs) {
			dispatch(addHasChecked(survey));
			dispatch(removeIsChecking(survey));
		} else { 
			const { lineId } = linesAggs[0];
			const histories = await fetchLineHistorySummaries({ lineId });
			const { appStates, reports } = histories;
			const hasUserData = (appStates && appStates.length) || (reports && reports.length);
			if (hasUserData) {
				dispatch(addHasUserData(survey));
			}
			dispatch(addHasChecked(survey));
			dispatch(removeIsChecking(survey));
		}
	}
};

export { thunkCheckSurveyHistory };
